module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Enrollments")]), _vm._v(" "), (_vm.enrollments == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no enrollments.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-4": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.enrollments), function(item, index) {
    return _c('v-card', {
      key: item.enrollmentId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("bookmark_border")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.enrollmentName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": "",
        "to": '/Trials/enrollments/' + item.enrollmentId
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [
      [_c('app-edit-enrollment-dialog', {
        attrs: {
          "enrollment": _vm.enrollment(index)
        }
      })]
    ], 2)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteTrial(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "md1": "",
      "ml-0": "",
      "mr-0": "",
      "mb-0": "",
      "mt-4": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.enrollments), function(item) {
    return _c('v-card', {
      key: item.enrollmentId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [(_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteEnrollment(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 cyan--text text--darken-3 text-center",
    attrs: {
      "align-center": "",
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "to": '/enrollment/new'
    }
  }, [_vm._v("New Enrollment")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d0dd400","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Enrollments/Archive.vue
// module id = 698
// module chunks = 1